// const apiURL = 'https://localhost:44394/';
// const apiURL = 'https://mcb.api.duranm.me/';
const apiURL = 'https://api-multicotizador.mcb.uno/';
export class ServiciosRutas {

  serviciosOperaciones = apiURL + 'Operaciones';
  serviciosCatalogos =   apiURL + 'Catalogo';
  urlPdfCotizacion = apiURL + 'COTIZACION/';
}
